import { normalizeCheckItems } from "@/service/checkFlag";
import { mergeSelectionSections } from "@/service/InspectionSelectionSync";
import { ActionContext, ActionTree, GetterTree } from "vuex";
import { CouponData } from "@/model/Coupon";
import { Utils } from "@/service/util";
// インスタンス生成
const utilsInstance = new Utils();


let serverSelection: any = null;

const initialState: CouponData = {
  coupon: {
    subTotalZn: 0,
    subTotalZk: 0
  },
  proposal: {},
  tokuten: {},
  isConfirm: 0,
  waitAutoSave: 0,
  couponLimitZn: 0,
  couponLimitZk: 0
};
const actions: ActionTree<CouponData, any> = {
  setCouponFromServer({ commit }: ActionContext<CouponData, any>, payload: CouponData): void {
    commit("setCouponFromServer", payload);
  },
  setCouponFromSocket({ commit }: ActionContext<CouponData, any>, payload: CouponData): void {
    commit("setCouponFromSocket", payload);
  },
  setCoupon(
    { commit }: ActionContext<CouponData, any>,
    payload: CouponData
  ): void {
    commit("setCoupon", payload);
  },
  setCoupon2({ commit }: ActionContext<CouponData, any>, payload: number): void {
    commit("setCoupon2", payload);
  },
  setCoupon3({ commit }: ActionContext<CouponData, any>, payload: number): void {
    commit("setCoupon3", payload);
  },
  confirm({ commit }: ActionContext<CouponData, any>, payload: number): void {
    commit("confirm", payload);
  },
  autoSave({ commit }: ActionContext<CouponData, any>, payload: number): void {
    commit("autoSave", payload);
  },
  clearState({ commit }: ActionContext<CouponData, any>): void {
    commit("clearState");
  },
  updateSubTotal({ commit }: ActionContext<CouponData, any>, payload: any): void {
    commit("updateSubTotal", payload);
  }
};

const mutations = {
  setCouponFromServer(state: CouponData, payload: CouponData) {
    serverSelection = utilsInstance.deepCopy(payload);
    mutations.setCoupon(state, payload);
  },
  setCouponFromSocket(state: CouponData, payload: CouponData) {
    const snapshot = utilsInstance.deepCopy(payload);
    const merged = mergeSelectionSections(serverSelection, state, payload, ["coupon","proposal","tokuten"]);
    mutations.setCoupon(state, merged);
    serverSelection = snapshot;
  },
  
  setCoupon(state: CouponData, payload: CouponData) {
    if (payload.coupon) {
      payload = { ...payload, coupon: { ...payload.coupon, items: normalizeCheckItems(payload.coupon.items) } };
    }
    if (payload.proposal) {
      payload = { ...payload, proposal: { ...payload.proposal, items: normalizeCheckItems(payload.proposal.items) } };
    }
    if (payload.tokuten) {
      payload = { ...payload, tokuten: { ...payload.tokuten, items: normalizeCheckItems(payload.tokuten.items) } };
    }
    /** 2021-05-31 sh #7126 fix add manual input [START] */
    // state.couponOld = deepCopy(state.coupon);
    state.couponOld = utilsInstance.deepCopy(state.coupon);
    /** 2021-05-31 sh #7126 fix add manual input [END] */
    Object.assign(state, payload);
  },
  setCoupon2(state: CouponData, payload: number) {
    state.couponLimitZn = payload;
  },
  setCoupon3(state: CouponData, payload: number) {
    state.couponLimitZk = payload;
  },
  confirm(state: CouponData, payload: number) {
    state.isConfirm = payload;
  },
  autoSave(state: CouponData, payload: number) {
    state.waitAutoSave = payload;
  },
  clearState(state: CouponData) {
    serverSelection = null;
    Object.assign(state, { ...initialState });
  },
  updateSubTotal(state: CouponData, payload: any) {
    if (state.coupon) {
      state.coupon.subTotalZk = payload.subTotalZk;
      state.coupon.subTotalZn = payload.subTotalZn;
    }
  }
};

const getters: GetterTree<CouponData, any> = {
  hasData(state: CouponData) {
    if (state.coupon && state.coupon.items) {
      return true;
    }
    return false;
  },
  currentState(state: CouponData) {
    return state;
  },
  total(state: CouponData) {
    if (state.coupon) {
      const { subTotalZn, subTotalZk, items } = state.coupon;
      return { subTotalZn, subTotalZk, isConfirm: state.isConfirm, items };
    }
    return null;
  },
  hasTokuten(state: CouponData) {
    return !!(state.tokuten && state.tokuten.items && state.tokuten.items.length > 0);
  },
  hasProposal(state: CouponData) {
    return !!(state.proposal && state.proposal.items && state.proposal.items.length > 0);
  },
  waitingAutoSave(state: CouponData) {
    return state.waitAutoSave;
  },
  isConfirm(state: CouponData) {
    return state.isConfirm;
  },
  couponLimitZn(state: CouponData) {
    return state.couponLimitZn;
  },
  couponLimitZk(state: CouponData) {
    return state.couponLimitZk;
  }
};

// const utils: any = new Utils();
const namespaced: boolean = true;
export default {
  namespaced,
  state: { ...initialState },
  getters,
  actions,
  mutations
};
